import { ActionIcon, Indicator } from '@mantine/core';
import { IconUpload } from '@tabler/icons-react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { useUploadStore } from '../uploadStore';

export function UploadButton() {
  const { authData } = useAuth();
  const openDrawer = useUploadStore((s) => s.openDrawer);
  const items = useUploadStore((s) => s.items);

  // Permission check: hide if user lacks ingest permission
  if (!authData?.cpuser.permissions.ingest) return null;

  const activeCount = items.filter(
    (i) => i.status === 'pending' || i.status === 'creating' || i.status === 'uploading' || i.status === 'processing'
  ).length;

  return (
    <Indicator
      label={activeCount}
      size={16}
      disabled={activeCount === 0}
      color="blue"
      processing={activeCount > 0}
    >
      <ActionIcon variant="subtle" size="lg" onClick={openDrawer} aria-label="Upload videos">
        <IconUpload size={20} />
      </ActionIcon>
    </Indicator>
  );
}
